export const hiringCompanySettingsTabs = [
  {
    name: "Company Details",
    path: "/settings/company-details",
  },
  {
    name: "Account Members",
    path: "/settings/company-details/account-members",
  },
];
